import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../gd-components/base-component/base-component";

const main = () => import(/* webpackChunkName: "export-to-csv" */ './export-to-csv-form-main');

module.exports = class Main extends BaseComponent {

    static propTypes = {
        params: PropTypes.shape({
            exportType: PropTypes.oneOf([
                gd.const.exportToCSV.types.WORKLOAD_TYPE,
                gd.const.exportToCSV.types.TASKS_LIST_TYPE,
                gd.const.exportToCSV.types.NOTES_LIST_TYPE,
                gd.const.exportToCSV.types.TASKS_BOARD_TYPE,
                gd.const.exportToCSV.types.PROJECT_LIST_TYPE,
                gd.const.exportToCSV.types.UNIVERSAL_TYPE,
            ]),
            exportDataManager: PropTypes.object.isRequired,
            onSubmit: PropTypes.func.isRequired,
        })
    };

    constructor(props) {
        super(props);

        this.state = {
            chunkLoaded: false
        };
    }

    componentDidMount() {
        main().then((component)=>{
            this.Main = component.default;
            this.setState({
                chunkLoaded: true
            });
        });
    }

    render() {
        if (this.state.chunkLoaded) {
            const { Main } = this;
            return <Main {...this.props.params}/>;
        }


        return (
            <div className="loading-container">
                <div className="loading-block">
                    <img className="loading-image" src="/app/web/skin/common/loader/app-loading.gif" />
                    <div className="loading-label">Loading...</div>
                </div>
            </div>
        )
    }
};
